import { render, staticRenderFns } from "./historywarn.vue?vue&type=template&id=bf050146&scoped=true&"
import script from "./historywarn.vue?vue&type=script&lang=js&"
export * from "./historywarn.vue?vue&type=script&lang=js&"
import style0 from "./historywarn.vue?vue&type=style&index=0&id=bf050146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf050146",
  null
  
)

export default component.exports